module.exports = __webpack_public_path__ + "stories/img/q-city-logo.126a975c.png";